//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const BatchService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unit/batch/loadscreenview", vo, successCallback, failureCallback);
    },
    changeTitle: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unit/batch/changetitle", vo, successCallback, failureCallback);
    },
    saveUnit: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unit/batch/saveunit", vo, successCallback, failureCallback);
    },
    deleteUnit: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unit/batch/deleteunit", { id }, successCallback, failureCallback);
    },
    changeOrder: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unit/batch/changeorder", vo, successCallback, failureCallback);
    },
};

export default BatchService;
